import React from 'react'
import './basic-button.css'

function BasicButton (props) {
  const {
    type = 'button',
    buttonStatus = 'primary',
    disabled = false,
    className = '',
    onClick,
    text,
    children,
    href,
    ...otherProps
  } = props
  if (type === 'button' || type === 'submit') {
    return (<button
      type={type}
      onClick={type === 'button' ? onClick : null}
      className={`basic-button ${buttonStatus}${disabled ? ' disabled' : ''} ${className}`}
      disabled={disabled}
      {...otherProps}>
      {text}
      {children}
    </button>)
  } else if (type === 'link') {
    return (
      <a className={`basic-button link-button ${buttonStatus}`} href={href} {...otherProps}>
        {text}
        {children}
      </a>
    )
  }
}

export { BasicButton }
